// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_6c97079b1b--wrap--vTZ1i","star":"_6c97079b1b--star--Pz35g","star-size_s":"_6c97079b1b--star-size_s--WZDRy","star-size_m":"_6c97079b1b--star-size_m--GxfVJ"};